import { render } from "./ContactsEntity.vue?vue&type=template&id=f24e9eaa"
import script from "./ContactsEntity.vue?vue&type=script&lang=js"
export * from "./ContactsEntity.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__